import RmnBanner from 'components/Rmn/RmnBanner/RmnBanner';

export default RmnBanner;
